import type { Licencie } from "@carnet/api/isia";

const forms = {
  signin: {
    Email: "",
    Civilite: undefined,
    Prenom: "",
    Nom: "",
    DateNaissance: "",
    AutoriserVisibiliteCarnet: true,
    AutoriserValidationCarnet: true,
  } as Licencie,
  register: {
    Identifiant: "",
    AutoriserVisibiliteCarnet: true,
    AutoriserValidationCarnet: true,
  } as Licencie,
};

export type FormType = keyof typeof forms;
export type FormRegistry = typeof forms;

export const VALID_FORM_TYPES = Object.keys(forms) as FormType[];
export const FORM_TTL_MS = 60 * 60 * 1000; // 1 hour

// Clés laissées par le brouillon d'activité, désormais porté par son propre cookie : une
// session créée avant la migration les traîne indéfiniment (defu ne sait pas retirer une clé).
export const OBSOLETE_SESSION_FORM_KEYS = ["activityForm", "activityFormSavedAt", "activityFormDone"] as const;

export const getFormDefault = <K extends FormType>(key: K): FormRegistry[K] => ({ ...forms[key] });
